import { msg } from '@lingui/core/macro';
import { ToastOptions } from 'react-toastify';
import { MessageDescriptor } from 'shared/i18n';

/** Тост о незаполненном регламенте: показывают все три места, откуда запускают синхронизацию.
 *
 * `autoClose: false` — оператору надо успеть уйти в настройки соревнования, а `pre-line`
 * оставляет перенос строки перед подсказкой про вкладку. Текст — дескриптор: переводит место показа. */
export const MISSING_PERIODS_SETTINGS_TOAST: { message: MessageDescriptor; options: ToastOptions } = {
  message: msg`Добавьте "Количество периодов в матче" и "Длительность матча". \nВ настройках турнира перейдите на вкладку "Условия", а затем в "Регламент".`,
  options: {
    autoClose: false,
    bodyStyle: {
      whiteSpace: 'pre-line',
    },
  },
};
